import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueQRCodeComponent from 'vue-qrcode-component'

import router from './router'
import store from './store'
import App from './App.vue'

// Custom CSS
import './assets/css/app.css'
import './assets/css/news.css'
import './assets/css/register.css'
import './assets/css/online.scss'
// import './assets/css/styles.css'
import './assets/css/new.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/clipboard'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.component('qr-code', VueQRCodeComponent)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
